
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guia-de-compras",
      function () {
        return require("private-next-pages/guia-de-compras/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guia-de-compras"])
      });
    }
  